<div class="createAccount__bodySection"   [ngClass]="{'sdex-env': envType == appType.dams || envType == appType.clms}" >
  <div class="createAccount__body" [ngClass]="{'sdex-env-dams_box': envType == appType.dams || envType == appType.clms}">
    <div class="createAccount__section"
      [ngClass]="{'sdex-env-dams': envType == appType.dams || envType == appType.clms, 'sdex-env-dams-form5':showForm5 && envType !== appType.sdex, 'sdex-env-sdex-form5':showForm5 && envType == appType.sdex}">
      @if (isLogoLoaded) {
        <div>
          <div  ngClass="{{(customUrldata?.logo?.length && envType!=='SDEX') ? 'accountLogin__logo_url' : envType =='SDEX'? 'accountLogin__logo':'accountLogin__logo_dc'}}">
            @if (envType=='SDEX' ) {
              <div class="accountLogin__logo">
                <img src="../../../assets/Images/login/headerLogo.svg" alt="headerLogo">
                <img src="../../../assets/Images/login/sdexLogo.svg" alt="sdexLogo">
              </div>
            }
            <div ngClass="{{customUrldata?.logo?.length ? 'accountLogin__logo_url' : envType =='SDEX'? 'accountLogin__logo':'accountLogin__logo_dc'}}">
              @if (envType!=='SDEX' && customUrldata?.logo?.length) {
                <img ngClass="{{customUrldata?.logo?.length ? 'account_login_customlogo_url' : 'account_login_customlogo'}}"
                  [src]="customUrldata?.logo" alt="sdex">
              }
              <div>
                @if (envType!=='SDEX' &&(!customUrldata?.logo?.length)) {
                  <img ngClass="{{customUrldata?.logo?.length ? 'account_login_customlogo_url' : 'account_login_customlogo'}}"
                    [src]="'../../../assets/Images/login/headerLogo.svg'" alt="sdex">
                  }
                  @if (envType!=='SDEX'  &&(!customUrldata?.logo?.length)) {
                    <img src="../../../assets/Images/login/sdexLogo.svg" alt="sdex">
                  }
                </div>
              </div>
            </div>
          </div>
        }
        @if (showForm4) {
          <form (ngSubmit)="verifySecondaryUser()" name="registerForm" [formGroup]="secondaryForm">
            <div class="createAccount__signIn">
              <div class="createAccount__setup">Setup your Account</div>
              <div class="createAccount__inputWrapper1 pt-4">
                <div class="createAccount__inputSection">
                  <div class="createAccount__inputLabel">
                    Enter a registered email
                  </div>
                  <app-input-filed placeholder="Email" [control]="$any(secondaryForm).controls['emailAddress']"
                    id="emailAddress" (inputEvent)="getInputValue($event)" required>
                  </app-input-filed>
                  @if (secondaryForm.get('emailAddress')?.invalid &&
                    (secondaryForm.get('emailAddress')?.dirty ||
                    secondaryForm.get('emailAddress')?.touched)) {
                    <div class="error-validation"
                      >
                      @if (secondaryForm.get('emailAddress')?.errors?.['pattern']) {
                        <div>
                          <small class="text-danger">Please enter a valid email address</small>
                        </div>
                      }
                      @if (secondaryForm.get('emailAddress')?.errors?.['required']) {
                        <div>
                          <small class="text-danger">Email is required</small>
                        </div>
                      }
                    </div>
                  }
                  <div class="mt-2 text-center text-danger error-msg-wd">
                    {{ errorMsg }}
                  </div>
                </div>
              </div>
              <div class="createAccount__error">
                <img src="../../../assets/Images/login/error.svg" alt="error"/>
                <div class="createAccount__errorText">
                  You will receive a mail with an OTP to verify your account
                </div>
              </div>
            </div>
            <div class="createAccount__button">
              <app-common-button buttonClass="smallFilledButton" [buttonLabel]="'Verify Email'"
                custButtonClass="custButtonClass" disableButtonClass="largeButtonDisable" [loadingIcon]="verifyLoader" [typeBtn]="true" [disabled]="secondaryForm.invalid || verifyLoader">
              </app-common-button>
            </div>
            <div class="accountLogin__signUp">
              <div class="accountLogin__signupText">Already have an account?</div>
              <a style="text-decoration: none" [routerLink]="['/home']">
                <div class="accountLogin__passwordText">Sign In</div>
              </a>
            </div>
          </form>
        }

        @if (showForm5) {
          <form #form2="ngForm" name="registerForm2" [formGroup]="registerForm5" class="p-3">
            <div class="createAccount__section">
              <div class="createAccount__signIn">
                <div class="createAccount__setup">Setup Password</div>
                <div class="createAccount__addCredintials">
                  Verify OTP and create a password
                </div>
                <div class="createAccount__inputWrapper">
                  <div class="createAccount__inputSection">
                    <div class="createAccount__inputLabel">Enter an OTP</div>
                    <div class="createAccount__inputWrapper">
                      <input class="createAccount__input" placeholder="******" formControlName="otp" id="password"
                        type="text" maxlength="6" (input)="validateOTP($event)" required />
                        <button [ngClass]="disabled ?'disableBtn':'createAccount__verifyButton'" [disabled]="disabled"
                        (click)="resendOTP()">Resend OTP</button>
                      </div>
                      @if (
                        !registerForm5.controls['otp'].valid &&
                        registerForm5.get('otp')?.touched
                        ) {
                        <div>
                          <small class="text-danger">OTP is required</small>
                        </div>
                      }
                    </div>
                    <!-- new -->
                    <div class="createAccount__inputSection">
                      <div class="createAccount__inputLabel">Create a password</div>
                      <div class="usersFilter__branchesField">
                        <div class="usersFilter__branchWrappar">
                  <input class="usersFilter__input" style="
                      border: none;
                      outline: none !important;
                      box-shadow: none !important;
                      border-color: #000 !important;
                      width: 336px;
                    " placeholder="***********" formControlName="password" class="" id="password"
                            oncopy = "return false"
                            onpaste =" return false"
                            type="{{ hide2 ? 'password' : 'text' }}" required />
                            <fa-icon class="usersFilter__searchIcon" [icon]="hide2 ? faEye : faEyeSlash" (click)="hide2 = !hide2"
                            [attr.aria-label]="'Hide2 Password'" [attr.aria-pressed]="hide2"></fa-icon>
                          </div>
                          @if (
                            !registerForm5.controls['password'].valid &&
                            registerForm5.controls['password'].touched
                            ) {
                            <div class="invalid-feedback">
                              <small class="text-danger">Password is required</small>
                            </div>
                          }
                        </div>
                        @if (registerForm5.get('password')?.hasError('pattern')) {
                          <div class="createAccount__error"
                            style="max-width:400px;margin-left: 0px;">
                            <img src="../../../assets/Images/login/error.svg" alt="error"/>
                            <small class="text-muted">Hint- Minimum of 8 characters with a uppercase, lowercase,
                            special character and a number required.</small>
                          </div>
                        }
                      </div>
                      <!-- new -->
                      <div class="createAccount__inputSection">
                        <div class="createAccount__inputLabel">Confirm password</div>
                        <div class="usersFilter__branchesField">
                          <div class="usersFilter__branchWrappar">
                  <input class="usersFilter__input" style="
                      border: none;
                      outline: none !important;
                      box-shadow: none !important;
                      border-color: #000 !important;
                      width: 336px;" 
                              oncopy = "return false"
                              onpaste =" return false"
                              id="repassword" type="{{ hide ? 'password' : 'text' }}" placeholder="***********"
                              formControlName="repassword" class="" [type]="hide ? 'password' : 'text'" required />
                              <fa-icon class="usersFilter__searchIcon" [icon]="hide ? faEye : faEyeSlash" (click)="hide = !hide"
                              [attr.aria-label]="'Hide Password'" [attr.aria-pressed]="hide"></fa-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (
                        registerForm5.get('password')?.value !==
                        registerForm5.get('repassword')?.value &&
                        registerForm5.get('repassword')?.touched
                        ) {
                        <div class="createAccount__error createAccount__addCredintials error-validation" style="margin-bottom: 0px;">
                          Passwords do not match.
                        </div>
                      }
                      @if (errMsg) {
                        <div class="createAccount__error createAccount__addCredintials error-validation">
                          {{ errMsg }}
                        </div>
                      }
                    </div>
                    <div class="createAccount__button" style="margin-top: 24.09px;" >
                      <button  [ngClass]="registerForm5.invalid ? 'buttonDisable' : 'createAccount__signInButton'"
                        [disabled]="registerForm5.invalid" (click)="onVerify5()">
                        @if (!verifyLoader) {
                          <span>Submit</span>
                        }
                        @if (verifyLoader) {
                          <span>
                            <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
                          </span>
                        }
                      </button>
                    </div>
                  </div>
                  @if (ifReg) {
                    <div class="button-row text-center verify-links">
                      <p>Registered Already? <a [routerLink]="['/home']">Sign In</a></p>
                    </div>
                  }
                </form>
              }

              @if (showForm3) {
                <form name="congratsForm" class="p-3">
                  <div>
                    <div class="cong-reg text-center">
                      <i class="fa-regular fa-check"></i>
                      <h2>Congratulations!</h2>
                      <p>Your registration has been Successfully completed.</p>
                    </div>
                  </div>
                  <div class="d-flex flex-column align-items-center text-center">
                    <app-common-button [routerLink]="['/home']" buttonClass="smallbutton text-center"
                    buttonLabel="Login"></app-common-button>
                  </div>
                </form>
              }
            </div>

            @if (envType=='SDEX') {
              <app-logo></app-logo>
            }

          </div>
        </div>